module.exports = {
  title: 'Unlock Twodos with Reanimated, Gesture Handler and Skia',
  author: 'Enzo Manuel Mangano',
  date: '2024-04-17',
  slug: 'twodos-slide',
  tags: ['reanimated', 'gesture-handler', 'skia'],
};
